import React, { useState, useEffect } from "react";
import { Form, Button, Table } from "antd";
import { FormItemTypeEnum } from "../../../../components2/YhFormBox/Types"
import { YhFormItemsBox } from "../../../../components2/YhFormBox"
import { useDataBranchModel } from "../dataBranchModel"
import useMdmModel from "../../../../model/mdmModel"
import { useNavModel } from "../../../../model/navModel";
import { DetailType } from "../../../../types/FmsEnums";
import { IBranchInsert, IBranchUpadata } from "../dataBranchTypes";
import { setTitle } from "../../../../utils/utils"
const BranchDetail = () => {
    const [form] = Form.useForm();
    const { mdmCatalog, mdmBranch } = useMdmModel();
    const { selectedNavId, addNav, closeNav, getSelectedNavState, replaceNav } = useNavModel()
    const { addParam, selectedRow, updataAddParam, updataEditParam, insertDetail, updataDetail } = useDataBranchModel()
    const [modes, setModes] = useState<any>(getSelectedNavState("state"))
    const { id, pageParams } = modes
    const { mode, id: ids } = pageParams
    useEffect(() => {
        if (mode == DetailType.add) {
            form.setFieldsValue(addParam)
        } else if (mode == DetailType.edit || mode == DetailType.look) {
            form.setFieldsValue(selectedRow)
        }
    }, [])
    const onFinish = (values: IBranchInsert | IBranchUpadata) => {
        if (mode == DetailType.add) {
            insertDetail(values).then(res=> res && close())
        } else if (mode == DetailType.edit) {
            updataDetail(values as IBranchUpadata).then(res=> res && close())
        }
    }
    const items = [
        {
            type: FormItemTypeEnum.Input,
            span: 8,
            fieldLabel: "分支编码",
            labelCol: { span: 6 },
            fieldName: "code",
            // options: mdmBranch
        },
        {
            type: FormItemTypeEnum.Input,
            span: 8,
            fieldLabel: "分支名称",
            labelCol: { span: 6 },
            fieldName: "name",
        },
        {
            type: FormItemTypeEnum.Select,
            span: 8,
            fieldLabel: "数据目录编码",
            labelCol: { span: 6 },
            fieldName: "catalog",
            options: mdmCatalog
        }
    ]
    const close = () => {
        replaceNav(selectedNavId, "1-2")
    }
    const title = <div className="font-bold font-size-lg">{setTitle(mode)}数据分支</div>
    const action = <>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            hidden={mode == DetailType.look}
            onClick={() => form.submit()}
        >保存</Button>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            hidden={mode == DetailType.look}
            onClick={() => form.resetFields()}
        >重置</Button>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={() => {close()}}
        >取消</Button>
    </>
    return <Form
        form={form}
        onValuesChange={mode == DetailType.add ? updataAddParam : updataEditParam}
        onFinish={onFinish}
    >
        <YhFormItemsBox disabled={mode == DetailType.look} items={items} title={title} action={action} IclassName="p-20" />
    </Form>
}
export default BranchDetail